import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Button, Typography } from "@material-tailwind/react";
import { portalApi } from "../services/portalApi";

export default function PortalRevistasBaja() {
  const [params] = useSearchParams();
  const email = (params.get("email") || "").trim();
  const token = (params.get("token") || "").trim();
  const [status, setStatus] = useState("idle"); // idle | loading | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!email || !token) {
      setStatus("error");
      setMessage("Enlace de baja incompleto.");
    }
  }, [email, token]);

  async function confirm() {
    setStatus("loading");
    try {
      const r = await portalApi.revistaUnsubscribe({ email, token });
      setStatus("ok");
      setMessage(r?.message || "Te has dado de baja.");
    } catch (err) {
      setStatus("error");
      setMessage(err?.message || "No se pudo procesar la baja.");
    }
  }

  return (
    <div className="max-w-md mx-auto w-full py-8">
      <Typography variant="h2" className="font-sans text-brand-dark text-2xl font-semibold mb-3">
        Baja de Conexión Siete
      </Typography>
      {status === "ok" ? (
        <p className="text-brand-gray">{message}</p>
      ) : status === "error" && !email ? (
        <p className="text-red-600 text-sm">{message}</p>
      ) : (
        <>
          <p className="text-brand-gray text-sm mb-4">
            Confirma que ya no deseas recibir correos de Conexión Siete
            {email ? (
              <>
                {" "}
                en <strong>{email}</strong>
              </>
            ) : null}
            .
          </p>
          {status === "error" && message ? (
            <p className="text-red-600 text-sm mb-3">{message}</p>
          ) : null}
          <Button
            onClick={confirm}
            disabled={status === "loading" || !email || !token}
            className="bg-brand-lavender text-white normal-case"
          >
            {status === "loading" ? "Procesando…" : "Confirmar baja"}
          </Button>
        </>
      )}
      <p className="mt-6 text-sm">
        <Link to="/revistas" className="text-brand-lavender hover:underline">
          Volver a la revista
        </Link>
      </p>
    </div>
  );
}
